/**
 * #value.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
import { formFieldTypeFromJSON, formFieldTypeToJSON } from "./type.js";
function createBaseFormFieldValue() {
    return {
        fieldType: 0,
        isSecret: undefined,
        stringValue: undefined,
        numberValue: undefined,
        boolValue: undefined,
        listValue: undefined,
        selectionValue: undefined,
        groupValue: undefined,
    };
}
export const FormFieldValue = {
    $type: "devvit.ui.form_builder.v1alpha.FormFieldValue",
    encode(message, writer = _m0.Writer.create()) {
        if (message.fieldType !== 0) {
            writer.uint32(8).int32(message.fieldType);
        }
        if (message.isSecret !== undefined) {
            writer.uint32(800).bool(message.isSecret);
        }
        if (message.stringValue !== undefined) {
            writer.uint32(18).string(message.stringValue);
        }
        if (message.numberValue !== undefined) {
            writer.uint32(25).double(message.numberValue);
        }
        if (message.boolValue !== undefined) {
            writer.uint32(32).bool(message.boolValue);
        }
        if (message.listValue !== undefined) {
            FormFieldValue_ListValue.encode(message.listValue, writer.uint32(42).fork()).ldelim();
        }
        if (message.selectionValue !== undefined) {
            FormFieldValue_SelectionValue.encode(message.selectionValue, writer.uint32(50).fork()).ldelim();
        }
        if (message.groupValue !== undefined) {
            FormFieldValue_GroupValue.encode(message.groupValue, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFormFieldValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.fieldType = reader.int32();
                    continue;
                case 100:
                    if (tag !== 800) {
                        break;
                    }
                    message.isSecret = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.stringValue = reader.string();
                    continue;
                case 3:
                    if (tag !== 25) {
                        break;
                    }
                    message.numberValue = reader.double();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.boolValue = reader.bool();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.listValue = FormFieldValue_ListValue.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.selectionValue = FormFieldValue_SelectionValue.decode(reader, reader.uint32());
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.groupValue = FormFieldValue_GroupValue.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            fieldType: isSet(object.fieldType) ? formFieldTypeFromJSON(object.fieldType) : 0,
            isSecret: isSet(object.isSecret) ? globalThis.Boolean(object.isSecret) : undefined,
            stringValue: isSet(object.stringValue) ? globalThis.String(object.stringValue) : undefined,
            numberValue: isSet(object.numberValue) ? globalThis.Number(object.numberValue) : undefined,
            boolValue: isSet(object.boolValue) ? globalThis.Boolean(object.boolValue) : undefined,
            listValue: isSet(object.listValue) ? FormFieldValue_ListValue.fromJSON(object.listValue) : undefined,
            selectionValue: isSet(object.selectionValue)
                ? FormFieldValue_SelectionValue.fromJSON(object.selectionValue)
                : undefined,
            groupValue: isSet(object.groupValue) ? FormFieldValue_GroupValue.fromJSON(object.groupValue) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.fieldType !== 0) {
            obj.fieldType = formFieldTypeToJSON(message.fieldType);
        }
        if (message.isSecret !== undefined) {
            obj.isSecret = message.isSecret;
        }
        if (message.stringValue !== undefined) {
            obj.stringValue = message.stringValue;
        }
        if (message.numberValue !== undefined) {
            obj.numberValue = message.numberValue;
        }
        if (message.boolValue !== undefined) {
            obj.boolValue = message.boolValue;
        }
        if (message.listValue !== undefined) {
            obj.listValue = FormFieldValue_ListValue.toJSON(message.listValue);
        }
        if (message.selectionValue !== undefined) {
            obj.selectionValue = FormFieldValue_SelectionValue.toJSON(message.selectionValue);
        }
        if (message.groupValue !== undefined) {
            obj.groupValue = FormFieldValue_GroupValue.toJSON(message.groupValue);
        }
        return obj;
    },
    create(base) {
        return FormFieldValue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFormFieldValue();
        message.fieldType = object.fieldType ?? 0;
        message.isSecret = object.isSecret ?? undefined;
        message.stringValue = object.stringValue ?? undefined;
        message.numberValue = object.numberValue ?? undefined;
        message.boolValue = object.boolValue ?? undefined;
        message.listValue = (object.listValue !== undefined && object.listValue !== null)
            ? FormFieldValue_ListValue.fromPartial(object.listValue)
            : undefined;
        message.selectionValue = (object.selectionValue !== undefined && object.selectionValue !== null)
            ? FormFieldValue_SelectionValue.fromPartial(object.selectionValue)
            : undefined;
        message.groupValue = (object.groupValue !== undefined && object.groupValue !== null)
            ? FormFieldValue_GroupValue.fromPartial(object.groupValue)
            : undefined;
        return message;
    },
};
messageTypeRegistry.set(FormFieldValue.$type, FormFieldValue);
function createBaseFormFieldValue_ListValue() {
    return { itemType: 0, items: [] };
}
export const FormFieldValue_ListValue = {
    $type: "devvit.ui.form_builder.v1alpha.FormFieldValue.ListValue",
    encode(message, writer = _m0.Writer.create()) {
        if (message.itemType !== 0) {
            writer.uint32(8).int32(message.itemType);
        }
        for (const v of message.items) {
            FormFieldValue.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFormFieldValue_ListValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.itemType = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.items.push(FormFieldValue.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            itemType: isSet(object.itemType) ? formFieldTypeFromJSON(object.itemType) : 0,
            items: globalThis.Array.isArray(object?.items) ? object.items.map((e) => FormFieldValue.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.itemType !== 0) {
            obj.itemType = formFieldTypeToJSON(message.itemType);
        }
        if (message.items?.length) {
            obj.items = message.items.map((e) => FormFieldValue.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return FormFieldValue_ListValue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFormFieldValue_ListValue();
        message.itemType = object.itemType ?? 0;
        message.items = object.items?.map((e) => FormFieldValue.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(FormFieldValue_ListValue.$type, FormFieldValue_ListValue);
function createBaseFormFieldValue_SelectionValue() {
    return { values: [] };
}
export const FormFieldValue_SelectionValue = {
    $type: "devvit.ui.form_builder.v1alpha.FormFieldValue.SelectionValue",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.values) {
            writer.uint32(10).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFormFieldValue_SelectionValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.values.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            values: globalThis.Array.isArray(object?.values) ? object.values.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.values?.length) {
            obj.values = message.values;
        }
        return obj;
    },
    create(base) {
        return FormFieldValue_SelectionValue.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFormFieldValue_SelectionValue();
        message.values = object.values?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(FormFieldValue_SelectionValue.$type, FormFieldValue_SelectionValue);
function createBaseFormFieldValue_GroupValue() {
    return {};
}
export const FormFieldValue_GroupValue = {
    $type: "devvit.ui.form_builder.v1alpha.FormFieldValue.GroupValue",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFormFieldValue_GroupValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return FormFieldValue_GroupValue.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseFormFieldValue_GroupValue();
        return message;
    },
};
messageTypeRegistry.set(FormFieldValue_GroupValue.$type, FormFieldValue_GroupValue);
function isSet(value) {
    return value !== null && value !== undefined;
}
